<template>
    <DFormRow
        :label="__('customers.contracts.prompt_cash_discount_percentage')"
        :error="errors.prompt_cash_discount_percentage"
    >
        <div
            role="group"
            class="form-group"
        >
            <DInput
                id="prompt_cash_discount_percentage"
                :model-value="modelValue"
                type="number"
                min="0"
                @update:modelValue="emit('update:modelValue', $event)"
                @update:checked="promptCashDiscountPercentageChanged"
            />
        </div>
    </DFormRow>
</template>

<script setup>
defineProps({
    modelValue: {
        type: Boolean,
        default: false
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const emit = defineEmits(['promptCashDiscountPercentageChanged', 'update:modelValue'])

function promptCashDiscountPercentageChanged (value) {
    emit('promptCashDiscountPercentageChanged', value)
}
</script>
